export default __webpack_public_path__ + "static/media/digital-ready-infrastructure.adb672df.svg";